import PropTypes from 'prop-types';
import React from 'react';

/**
 * Header used as the first child of a Criteria component.
 *
 * @displayName Header
 *
 * @param {Object} props Props
 * @returns {ReactElement} ReactElement
 */
export default function Header(props) {
  return (
    <div className='ux-criteria-header title extra-small'>{ props.children }</div>
  );
}

/**
 * PropType validation.
 *
 * @type {Object}
 * @private
 */
Header.propTypes = {
  /** The child elements */
  children: PropTypes.node
};



// WEBPACK FOOTER //
// ./node_modules/@ux/criteria/criteria-header.js